var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-carousel',_vm._g(_vm._b({},'b-carousel',_vm.$attrs,false),_vm.mountEventListeners),_vm._l((_vm.slides),function(slide){return _c('b-carousel-slide',{key:slide.id,attrs:{"caption":slide.caption,"text":slide.text,"img-src":slide.imageSource}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }